import React, { Component } from 'react';
class Hr extends Component {
    render() {
        return (<div className={(this.props.className || "") + " col-md-12"} style={{ borderTop: '1px solid #7a8eae', marginTop: 30 }}>&nbsp;</div>);
    }
}

export default Hr;